export const GRID_FULL_WIDTH = "col-start-1 col-span-3";
export const PAGE_TRANSITION_DURATION = 860; // ms
export const PAGE_TRANSITION_DELAY = 180; // ms
export const GAP_BETWEEN_VIEWS = 200; // px
export const SAFE_TRANSITION_DELAY = 50; // ms
